import React from "react";
import { ButtonToggle, ButtonToggleOption } from "@showitinc/showit-wc";

const AlignOptions = ({
  alignment = "left",
  onSelect,
  disabled,
  label = "Align",
  useJustify = true,
  context,
}) => {
  const checked = (value) => alignment === value;

  return (
    <ButtonToggle
      label={label}
      context={context}
      disabled={disabled}
      value={alignment}
      onSIChange={onSelect}
    >
      <ButtonToggleOption
        size="sm"
        value="left"
        icon="formatLeft"
        checked={checked("left")}
        disabled={disabled}
      />
      <ButtonToggleOption
        size="sm"
        value="center"
        icon="formatCenter"
        checked={checked("center")}
        disabled={disabled}
      />
      <ButtonToggleOption
        size="sm"
        value="right"
        icon="formatRight"
        checked={checked("right")}
        disabled={disabled}
      />
      {useJustify ? (
        <ButtonToggleOption
          size="sm"
          value="justify"
          icon="formatJustified"
          checked={checked("justify")}
          disabled={disabled}
        />
      ) : null}
    </ButtonToggle>
  );
};

export default AlignOptions;
